import React, { useState } from 'react'; import { Navigate, Route, Routes } from 'react-router-dom'; import { useAuth } from '../../auth/context/AuthContext';

import AdminSidebar from '../components/AdminSidebar'; import AdminDashboard from './AdminDashboard'; import FirmsPage from './FirmsPage'; import CreateFirmPage from './CreateFirmPage'; import FirmDetailsPage from './FirmDetailsPage'; import UsersPage from './UsersPage';

import '../styles/adminLayout.css';

const AdminLayout = () => { const { logout } = useAuth(); const [sidebarOpen, setSidebarOpen] = useState(false);

const closeSidebar = () => setSidebarOpen(false);

return ( <div className="admin-layout"> <button type="button" className="admin-menu-toggle" aria-label="Open navigation menu" aria-expanded={sidebarOpen} onClick={() => setSidebarOpen(true)} > <span /> <span /> <span /> </button>

  <AdminSidebar
    isOpen={sidebarOpen}
    onClose={closeSidebar}
    onLogout={() => {
      closeSidebar();
      logout();
    }}
  />

  <div className="admin-layout-content">
    <Routes>
      <Route index element={<AdminDashboard />} />
      <Route path="firms" element={<FirmsPage />} />
      <Route path="firms/create" element={<CreateFirmPage />} />
      <Route path="firms/:id" element={<FirmDetailsPage />} />
      <Route path="users" element={<UsersPage />} />
      <Route
        path="*"
        element={<Navigate to="/admin" replace />}
      />
    </Routes>
  </div>
</div>


); };

export default AdminLayout;